import { useQuery } from '@apollo/client';
import React, { Fragment } from 'react';
import MultiSelectInput from '@/se/components/inputs/MultiSelectInput';
import { organizationUserOptions } from '../../../../graph/users';
import { defaultTo } from 'lodash';

const toSelectOptions = (data, options = []) => (data ? data.map(id => options.find(_ => _.value === id)) : data);
const fromSelectOptions = data => (data ? data.map(({ value }) => value) : data);

const NotificationRecipients = ({ name = 'notificationRecipients', value, onChange, disabled }) => {
  // Replace deprecated graphql HOC with useQuery hook
  const { data, loading } = useQuery(organizationUserOptions);
  
  const options = defaultTo(data?.users, []).map(({ id, name, email }) => ({
    label: `${name} <${email}>`,
    value: id,
  }));

  const handleChange = value => onChange(fromSelectOptions(value));

  return (
    <Fragment>
      <MultiSelectInput
        name={name}
        options={options}
        onChange={handleChange}
        value={toSelectOptions(value, options)}
        loading={loading}
        disabled={disabled}
      />
    </Fragment>
  );
};

export default NotificationRecipients;
